import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Search } from "lucide-react";
import { api } from "@/lib/api";
import { rp, dEN, INVOICE_STATUS } from "@/lib/format";
import { PageHeader, Card, Pill, Empty, BigButton } from "@/components/admin/common";
import { Input } from "@/components/ui/input";

const TABS = [["", "All"], ["draft", "Draft"], ["sent", "Sent"], ["paid", "Paid"]];

export default function Invoices() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get("/admin/invoices", { params: { status, q } }).then((r) => setItems(r.data)), [status, q]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="max-w-5xl" data-testid="invoices-page">
      <PageHeader title="Invoices" subtitle="Every invoice is saved here. Marking one paid records the income in Keuangan."
        actions={<BigButton onClick={() => navigate("/admin/invoices/new")} data-testid="new-invoice-btn"><Plus className="w-5 h-5" />New invoice</BigButton>} />
      <div className="flex flex-wrap gap-2 mb-4">
        <div className="flex bg-white border border-border rounded-xl p-1">
          {TABS.map(([k, l]) => (
            <button key={l} onClick={() => setStatus(k)} data-testid={`invoices-tab-${l.toLowerCase()}`}
              className={`px-4 h-10 rounded-lg text-sm font-semibold ${status === k ? "bg-ocean text-white" : "text-slate-600"}`}>{l}</button>
          ))}
        </div>
        <div className="relative flex-1 min-w-[200px]"><Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search number or customer" className="h-12 pl-9" data-testid="invoices-search-input" /></div>
      </div>
      {items && !items.length && <Empty text="No invoices yet." testid="invoices-empty" />}
      <div className="space-y-2">
        {items?.map((i) => (
          <Link key={i.id} to={`/admin/invoices/${i.id}`} data-testid={`invoice-row-${i.id}`}>
            <Card className="p-4 flex items-center gap-3 hover:border-ocean transition-colors duration-150 mb-2">
              <div className="flex-1 min-w-0">
                <p className="font-extrabold">{i.number}</p>
                <p className="text-sm text-slate-500 truncate">{i.customer_name} · issued {dEN(i.issue_date)} · due {dEN(i.due_date)}</p>
              </div>
              <div className="text-right">
                <p className="font-bold">{rp(i.total)}</p>
                <Pill map={INVOICE_STATUS} value={i.status} />
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
